/* @flow */

function FriendlyError(message: string, cause: ?(string | Error), opts: ?Object) {
  Object.assign(this, opts, { message, cause });
}
FriendlyError.prototype = new Error();

export { FriendlyError };
